import http from "../http-common";

class LocalNetworkService {
  getLocalNetwork(folderPath: string) {
    return http.get(`/local-network?path=${folderPath}`);
  }
}

export default new LocalNetworkService();